import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'components/organisms/projected-ownership-force/actions';
import InputCheckbox from 'components/atoms/inputs/input-checkbox';

class ForcePlayers extends Component {
    onChange(isChecked) {
        this.props.dispatch(Action.set('ProjectedOwnershipForceIsEnabled', isChecked));
    }

    render() {
        const {projectedOwnershipForce} = this.props;
        return (
            <InputCheckbox
                label="Force at least"
                checked={projectedOwnershipForce.isEnabled()}
                onChange={::this.onChange}
            />
        );
    }
}

function mapStatesToProps(state) {
    return {
        projectedOwnershipForce: state.projectedOwnershipForce,
    };
}

export default connect(mapStatesToProps)(ForcePlayers);
